import { useState, useEffect } from 'react';
import Header from '../directives/header';
import {
  Container,
  Row,
  Col,
  Tab,
  Nav,
  Card,
  Button,
  Form,
} from 'react-bootstrap';
import Footer from '../directives/footer';
import '../css/blog.css';
import LatestNews from './latestNews';
import { submitContactDetailsAction } from '../../apis/apiAction';
import { Toaster, toast } from 'react-hot-toast';

const News = () => {
  const handleClose = () => {
    setFormData({ email: '' });
  };
  const [formData, setFormData] = useState({
    email: '',
  });

  const inputHandler = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const isValidate = () => {
    if (!formData.email) {
      toast.error('Email is required');
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Enter a valid email');
      return false;
    }
    return true;
  };

  const [positionClass, setPositionClass] = useState('relative');

  useEffect(() => {
    const updatePosition = () => {
      setPositionClass(window.innerWidth >= 992 ? 'absolute' : 'relative mb-5');
    };

    updatePosition(); // Set initial state
    window.addEventListener('resize', updatePosition);

    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  const submitContactDetails = async () => {
    if (!isValidate()) return;
    try {
      let res = await submitContactDetailsAction(formData);
      if (res.status) {
        toast.success('You are Subscribed!!');
        handleClose();
      } else {
        toast.error(res.message);
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <>
      <Header />
      <Toaster />
      <div
        className="subheader"
        style={{ background: 'url(assets/images/news.svg)' }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2 className="fw-bold text-white">News</h2>
              <p>
                Welcome to the Unitronix News Hub, where we bring you the latest
                updates, announcements, and insights from the world of
                blockchain, tokenized finance, and decentralized investments.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <section className="news">
        <LatestNews />
        <div className="getintouch">
          <Container>
            <Row>
              <Col lg={12} className="mb-4">
                <Card className="p-3 pb-0">
                  <Card.Body className="p-4 pb-0">
                    <Row className="">
                      <Col lg={6} className="">
                        <div className="pt-5">
                          <div className="mb-5">
                            <h1 className="fw-semibold text-white mb-0 text-capitalize">
                              Subscribe to our newsletter
                            </h1>
                          </div>
                          <Form className="my-4 subscribeForm">
                            <div className="d-flex align-items-center">
                              <Form.Control
                                type="email"
                                placeholder="Enter Your Email"
                                value={formData.email}
                                onChange={inputHandler}
                                name="email"
                                className="bg-white text-black box-shadow-none w-100 small"
                              />
                              <Button
                                className="text-black  text-nowrap px-4"
                                onClick={submitContactDetails}
                              >
                                Subscribe
                              </Button>
                            </div>
                          </Form>
                        </div>
                      </Col>
                      <Col lg={6} className=" text-center">
                        <div className="newsImg position-relative z-1">
                          <img src="assets/images/newsletter.svg" />
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                  <div>
                    <div className="particleImg">
                      <img src="assets/images/particle.gif" />
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <Footer />
    </>
  );
};
export default News;
